import { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { checkAccess } from "../accessControl";

// Map URL tour IDs to Firebase tour IDs
const TOUR_ID_MAP = {
  "san-juan-cofresi-treasure": "san-juan",
  "san-juan-cofresi-treasure-es": "san-juan", // Spanish version shares access with English
  "mexico-city-artifact-protocol": "mexico-city-scavenger-hunt-tour",
  "chicago": "chicago-scavenger-hunt-tour"
};

export default function RequirePurchase({ children, redirectOnDeny = false }) {
  const { user } = useAuth();
  const { tourId } = useParams();
  const [allowed, setAllowed] = useState(null); // null = loading

  // Get the Firebase tour ID from the URL tour ID
  const firebaseTourId = TOUR_ID_MAP[tourId] || tourId;

useEffect(() => {
  let mounted = true;

  checkAccess(user.email, firebaseTourId).then((ok) => {
  if (mounted) setAllowed(ok);
  });
  return () => {
    mounted = false;
  };
}, [user.email, firebaseTourId]);


  if (allowed === null) return <div style={{ padding: 24 }}>Checking access…</div>;

  if (!allowed) {
    if (redirectOnDeny) return <Navigate to="/" replace />;
    return (
      <div style={{ maxWidth: 520, margin: "40px auto", textAlign: "center" }}>
        <h2 style={{ marginBottom: 12 }}>You don’t have access to this tour.</h2>
        <p style={{ marginBottom: 8 }}>
          If you purchased with a different email, log out and sign in with that email.
        </p>
        <p>
          If this seems wrong, email support and include your order email and tour name.
        </p>
      </div>
    );
  }

  return children;
}
